import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import TopInfoLink from './TopInfoLink'

const CategoryLink = ({ query = {}, ad: { category } }) => {
  const lastCategory = category[category.length - 1]
  let newQuery
  if (lastCategory && lastCategory.id) {
    newQuery = { ..._.omit(query, 'page'), cg: lastCategory.id }
  }

  return (
    <TopInfoLink query={query} newQuery={newQuery}>
      {lastCategory.name}
    </TopInfoLink>
  )
}

CategoryLink.propTypes = {
  ad: PropTypes.shape({
    category: PropTypes.array.isRequired,
  }).isRequired,
  query: PropTypes.object,
}

export default CategoryLink
